import { useEffect, useRef } from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import useAnalytics from '../services/useAnalytics';
import { getAnalyticsTool } from '../utils/analytics';
import { beginGradientVisit } from '../utils/gradientAnalytics';

const ToolAnalytics = () => {
    const { pathname } = useLocation();
    const track = useAnalytics();
    const previousPath = useRef();

    useEffect(() => {
        if (previousPath.current === pathname) return;
        previousPath.current = pathname;
        beginGradientVisit(pathname);
        if (getAnalyticsTool(pathname)) track('tool_view');
    }, [pathname, track]);

    return null;
};

export default ToolAnalytics;
